import React, { useEffect, useRef, useState } from "react";
import Images from "../../assets/Image";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";

const ByApplicationComp = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("industrialsectors");
  const [offlineCategory, setOfflineCategory] = useState("industrialsectors");
  const [isOpen, setIsOpen] = useState(false);
  const [showIcons, setShowIcons] = useState(false);
  const form = useRef();

  const industrialsectors = [
    {
      image: Images?.industry1,
      sectorName: "Automobile",
      path: "/byindustry/automobile",
    },
    {
      image: Images?.industry2,
      sectorName: "Breweries & Distilleries",
      path: "/byindustry/breweries",
    },
    {
      image: Images?.industry3,
      sectorName: "Chemical",
      path: "/byindustry/chemical",
    },
    {
      image: Images?.industry4,
      sectorName: "electrical",
      path: "/byindustry/electrical",
    },
    {
      image: Images?.industry5,
      sectorName: "Food & Beverage",
      path: "/byindustry/foodandbeverage",
    },
    {
      image: Images?.industry6,
      sectorName: "Personal care",
      path: "/byindustry/personalCare",
    },
    {
      image: Images?.industry7,
      sectorName: "Pharma",
      path: "/byindustry/pharma",
    },
    {
      image: Images?.industry8,
      sectorName: "Telecom & Infrastructure",
      path: "/byindustry/telecom",
    },
  ];
  const thermalPrinter = [
    {
      image: Images?.industry5,
      sectorName: "Food & Beverage",
      path: "/byindustry/foodandbeverage",
    },
  ];
  const co2Laser = [
    {
      image: Images?.industry1,
      sectorName: "Automobile",
      path: "/byindustry/automobile",
    },
    {
      image: Images?.industry2,
      sectorName: "Breweries & Distilleries",
      path: "/byindustry/breweries",
    },
    {
      image: Images?.industry3,
      sectorName: "Chemical",
      path: "/byindustry/chemical",
    },
    {
      image: Images?.industry4,
      sectorName: "electrical",
      path: "/byindustry/electrical",
    },
    {
      image: Images?.industry5,
      sectorName: "Food & Beverage",
      path: "/byindustry/foodandbeverage",
    },
    {
      image: Images?.industry6,
      sectorName: "Personal care",
      path: "/byindustry/personalCare",
    },
    {
      image: Images?.industry7,
      sectorName: "Pharma",
      path: "/byindustry/pharma",
    },
    {
      image: Images?.industry8,
      sectorName: "Telecom & Infrastructure",
      path: "/byindustry/telecom",
    },
  ];

  useEffect(() => {
    if (isOpen) {
      setShowIcons(true);
    } else {
      setShowIcons(false);
    }
  }, [isOpen]);

  const getCategoryDescriptionOnline = () => {
    if (selectedCategory === "industrialsectors")
      return "CONTINUOUS INKJET PRINTERS";
    if (selectedCategory === "thermalPrinter")
      return "THERMAL TRANSFEROVER PRINTER";
    if (selectedCategory === "co2Laser") return "CO2 LASER";
  };

  const getCategoryDescriptionOffline = () => {
    if (offlineCategory === "industrialsectors")
      return "CONTINUOUS INKJET PRINTERS";
    if (offlineCategory === "thermalPrinter") return "HIGH RESOLUTION PRINTER";
    if (offlineCategory === "co2Laser") return "CO2 FIBER LASER";
  };

  const getCategoryList = () => {
    if (selectedCategory === "industrialsectors") return industrialsectors;
    if (selectedCategory === "thermalPrinter") return thermalPrinter;
    if (selectedCategory === "co2Laser") return co2Laser;
    return [];
  };

  const offlineCategoryList = () => {
    if (offlineCategory === "industrialsectors") return industrialsectors;
    if (offlineCategory === "thermalPrinter") return thermalPrinter;
    if (offlineCategory === "co2Laser") return co2Laser;
    return [];
  };

  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = 2;

  const [start, setStart] = useState(0);
  const perPage = 2;

  const handleNext = () => {
    if (startIndex + itemsPerPage < getCategoryList()?.length) {
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  const handlePrevious = () => {
    if (startIndex - itemsPerPage >= 0) {
      setStartIndex(startIndex - itemsPerPage);
    }
  };
  // Get the current items to display
  const currentItems = getCategoryList()?.slice(
    startIndex,
    startIndex + itemsPerPage,
  );

  // Function to handle "Next" (down arrow) button click
  const next = () => {
    if (start + perPage < offlineCategoryList()?.length) {
      setStart(start + perPage);
    }
  };

  // Function to handle "Previous" (up arrow) button click
  const previous = () => {
    if (start - perPage >= 0) {
      setStart(start - perPage);
    }
  };

  // Custom hook for Intersection Observer
  useEffect(() => {
    // For the address block
    const addressElements = document.querySelectorAll(
      ".contactEnquiryAddressBlock",
    );
    const addressObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible-address");
          }
        });
      },
      {
        threshold: 0.1,
      },
    );
    addressElements.forEach((el) => addressObserver.observe(el));

    // For the form fields
    const inputFields = document.querySelectorAll(".enquiryFormInputField");
    const formObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("visible-form");
            }, index * 300); // stagger the animation for each field
          }
        });
      },
      {
        threshold: 0.1,
      },
    );
    inputFields.forEach((input) => formObserver.observe(input));

    return () => {
      addressObserver.disconnect();
      formObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      setShowIcons(true);
    } else {
      setShowIcons(false);
    }
  }, [isOpen]);
  // Get the current items to display
  const currentCardItems = offlineCategoryList()?.slice(start, start + perPage);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_520oyz9", "template_xr5ts3y", form.current, {
        publicKey: "YI1Dlv7k1QHWv_o9e",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert("form submitted successfully..");
        },
        (error) => {
          console.log("FAILED...", error.text);
        },
      );
  };

  return (
    <>
      <div className="industry_heading_block">
        <div className="industry_left_block">
          <div className="contactus_heading_container">
            <h6 className="industry_heading my-3">BY APPLICATION</h6>
          </div>
        </div>
        <div className="industry_right_block">
          <div className="industry_image_block">
            <img
              src={Images?.byIndustryIcon}
              alt="no-image"
              className="image_icon"
            />
          </div>
        </div>
      </div>
      <div className="contact_us_sub_heading_block">
        <h5 className="contact_us_sub_title my-4">
          ONE‐STOP SOLUTIONS ‐ FROM AN ‘APPLICATION’ PERSPECTIVE
        </h5>
        <p className="event_content_para">
          Depending on the substrate and the product that you want to code and
          mark, you could probably end up purchasing different printers. Every
          printer has its own <br />
          unique set of features that makes it suitable for a certain set of
          substrates or consumables. We currently provide a versatile range of
          printers and consumables that <br />
          can be ably deployed for coding and marking on the following materials
        </p>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {" "}
        <h6 className="application-left-block-title">ONLINE</h6>
      </div>
      <div className="applicationMainSection">
        <div className="applicationSubBlock">
          <div className="applicationLeftBlock">
            <h5
              className="application-left-block-title"
              style={{ textDecoration: "none" }}
            >
              ONLINE
            </h5>
            <button
              className={`application_left_block_btn ${selectedCategory === "industrialsectors" ? "active" : ""
                }`}
              onClick={() => setSelectedCategory("industrialsectors")}
            >
              CONTINUOUS INKJET PRINTER
            </button>

            <button
              className={`application_left_block_btn ${selectedCategory === "thermalPrinter" ? "active" : ""
                }`}
              onClick={() => setSelectedCategory("thermalPrinter")}
            >
              THERMAL TRANSFEROVER PRINTER
            </button>

            <button
              className={`application_left_block_btn ${selectedCategory === "co2Laser" ? "active" : ""
                }`}
              onClick={() => setSelectedCategory("co2Laser")}
            >
              CO2 LASER
            </button>
          </div>
          <div className="applicationRightBlock">
            <h6 className="inkjet_printers_title">
              {getCategoryDescriptionOnline()}
            </h6>
            <div className="byapplication_card_block">
              {currentItems?.map((val, index) => {
                return (
                  <>
                    <div
                      className="byapplication_card"
                      key={index}
                      onClick={() => {
                        navigate(val?.path);
                      }}
                    >
                      <div className="byapplication_image-container">
                        <img
                          src={val?.image}
                          alt="no-image"
                          className="image_icon"
                        />
                      </div>
                      <h6 className="byapplication_card_title">
                        {val?.sectorName}
                      </h6>
                    </div>
                  </>
                );
              })}
            </div>

            <button
              onClick={handlePrevious}
              disabled={startIndex === 0}
              className="navigation_up_btn"
            >
              <img
                src={Images?.arrowUp}
                alt="no-image"
                className="navigate_image_icon"
              />
            </button>
            <button
              onClick={handleNext}
              disabled={startIndex + itemsPerPage >= getCategoryList()?.length}
              className="navigation_down_btn"
            >
              <img
                src={Images?.arrowDown}
                alt="no-image"
                className="navigate_image_icon"
              />
            </button>
          </div>
        </div>
      </div>
      <h6 className="application-left-block-title">OFFLINE</h6>
      <div className="applicationMainSection">
        <div className="applicationSubBlock">
          <div className="applicationLeftBlock">
            <h5
              className="application-left-block-title"
              style={{ textDecoration: "none" }}
            >
              OFFLINE
            </h5>
            <button
              className={`application_left_block_btn ${offlineCategory === "industrialsectors" ? "active" : ""
                }`}
              onClick={() => setOfflineCategory("industrialsectors")}
            >
              CONTINUOUS INKJET PRINTER
            </button>
            <button
              className={`application_left_block_btn ${offlineCategory === "thermalPrinter" ? "active" : ""
                }`}
              onClick={() => setOfflineCategory("thermalPrinter")}
            >
              HIGH RESOLUTION PRINTER
            </button>
            <button
              className={`application_left_block_btn ${offlineCategory === "co2Laser" ? "active" : ""
                }`}
              onClick={() => setOfflineCategory("co2Laser")}
            >
              CO2 FIBER LASER
            </button>
          </div>
          <div className="applicationRightBlock">
            <h6 className="inkjet_printers_title">
              {getCategoryDescriptionOffline()}
            </h6>
            <div className="byapplication_card_block">
              {currentCardItems?.map((val, index) => {
                return (
                  <>
                    <div
                      className="byapplication_card"
                      key={index}
                      onClick={() => {
                        navigate(val?.path);
                      }}
                    >
                      <div className="byapplication_image-container">
                        <img
                          src={val?.image}
                          alt="no-image"
                          className="image_icon"
                        />
                      </div>
                      <h6 className="byapplication_card_title">
                        {val?.sectorName}
                      </h6>
                    </div>
                  </>
                );
              })}
            </div>
            <div className="navigation-buttons">
              <button
                onClick={previous}
                disabled={start === 0}
                className="navigation_up_btn"
              >
                <img
                  src={Images?.arrowUp}
                  alt="no-image"
                  className="navigate_image_icon"
                />
              </button>
              <button
                onClick={next}
                disabled={start + perPage >= offlineCategoryList()?.length}
                className="navigation_down_btn"
              >
                <img
                  src={Images?.arrowDown}
                  alt="no-image"
                  className="navigate_image_icon"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      {!isOpen && (
        <>
          <button className="blog_content_bottom_btn">
            tap to connect here
          </button>
          <div
            className="blog_bottom_share"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            +
          </div>
        </>
      )}

      <div className="contactUs_Main_Section">
        <div className="contactusEnquirySection">
          <div className="contactUsEnquiryAddressBlock">
            <h6 className="enquiry_address_heading">Contact us</h6>
            <p className="--contact-address my-3">
              Have a question or interested in learning more about us and our
              products? Please contact us using the "Get in Touch" form below or
              by emailing <u style={{ color: "#3185D2" }}>enquiries@usppkg.com</u>
              / by calling  <u style={{ color: "#3185D2" }}>+91 9790934910</u>.
            </p>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.locationIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>

              <p className="--contact-address">
                Old No. 15/1, New No. 37, Dr.Muthulakshmi Salai,
                <br /> Lattice Bridge Road, Adyar, Chennai 600020, India.
              </p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.phoneCall}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">+91 9790934910</p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.meaageIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">enquiries@usppkg.com</p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.clockIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">
                Mon-Fri 9.30 am to 6.00 pm
                <br />
                Sat 9.30 am to 1.00 pm
              </p>
            </div>
          </div>
          <div className="contactUsEnquiryFormBlock">
            <h5 className="contactUsEnquiryFormHeading">Get In Touch</h5>
            <form ref={form} onSubmit={sendEmail}>
              <div>
                <input
                  type="text"
                  name="from_name"
                  className="enquiryFormInputField"
                  placeholder="Name"
                  required
                />
              </div>
              <div>
                <input
                  type="email"
                  name="from_email"
                  className="enquiryFormInputField"
                  placeholder="Email Id"
                  required
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="mobileNumber"
                  className="enquiryFormInputField"
                  placeholder="Mobile Number"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="need"
                  className="enquiryFormInputField"
                  placeholder="Need"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="message"
                  className="enquiryFormInputField"
                  placeholder="What is your need"
                  required
                />
              </div>
              <div className="contactus_btn_block">
                <button className="contactUsSubmitBtn">Submit Now</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {isOpen && (
        <>
          <div className={`blog_share_icons_block ${showIcons ? "show" : ""}`}>
            <img
              src={Images?.whatsappIcon}
              alt="whatsapp"
              className={`blog_share_icones_sizes ${showIcons ? "showIcon" : ""
                }`}
            />
            <img
              src={Images?.instagramIcon}
              alt="instagram"
              className={`blog_share_icones_sizes ${showIcons ? "showIcon" : ""
                }`}
            />
            <img
              src={Images?.facebookIcon}
              alt="facebook"
              className={`blog_share_icones_sizes ${showIcons ? "showIcon" : ""
                }`}
            />
            <img
              src={Images?.youtueIcon}
              alt="youtube"
              className={`blog_share_icones_sizes ${showIcons ? "showIcon" : ""
                }`}
            />
          </div>
          <div
            className="blog_bottom_share"
            onClick={() => {
              setIsOpen(!isOpen);
              setShowIcons(false);
            }}
          >
            x
          </div>
        </>
      )}
    </>
  );
};

export default ByApplicationComp;
